import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Home from './pages/Home';
import Projects from './pages/Projects';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Navbar from './components/Navbar';
import PageBackgroundAnimation from './components/PageBackgroundAnimation';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    // Wake up Render backend on site load (free tier spins down after inactivity)
    const apiBase = process.env.REACT_APP_API_URL;
    if (apiBase) {
      fetch(`${apiBase.replace(/\/+$/, '')}/`).catch(() => {
        // Silently wake up backend
      });
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <PageBackgroundAnimation />
      <div className="app-wrapper">
        <Navbar />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
